import ApiService from "@/common/api/api.service";
//import helpers from "@/common/utils/helpers";

const DemandaService = {
  
    get: function(id) {
        return ApiService.get(`Demanda/${id}`);
    },

    fetch(texto = "", porPagina = 0, pagina = 0) {
        return ApiService.get(`Demanda?Texto=${texto}&TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
    },

    store: function(form){
        if(form.id){
            return ApiService.put(`Demanda`, form);
        }else{
            return ApiService.post(`Demanda`, form);
        }
    },

    delete: function(id){
        return ApiService.delete(`Demanda?id=${id}`);
    }


};

export default DemandaService;
